// utils/greeting.ts
export const getGreeting = (): string => {
    const hours = new Date().getHours();
  
    if (hours >= 5 && hours < 12) {
      return 'Good Morning';
    } else if (hours >= 12 && hours < 18) {
      return 'Good Afternoon';
    } else {
      return 'Good Evening';
    }
  };
  